import type { HelpFile } from '../../types/help'
import { FunctionGroupRequestWizardTestIds } from '../../../testids/FunctionGroupRequestWizardTestIds'

export const functionGroupRequestWizardHelp: HelpFile = {
  docPage: '/docs/governance/function-groups',
  texts: {
    [FunctionGroupRequestWizardTestIds.functionGroupRequestWizardPage]: 'Wizard to request access via one or more function groups for yourself or another party.',
    [FunctionGroupRequestWizardTestIds.fgRequestStepContainer]: null,
    [FunctionGroupRequestWizardTestIds.btnCancel]: null,
    [FunctionGroupRequestWizardTestIds.btnCollapseAllFgs]: null,
    [FunctionGroupRequestWizardTestIds.btnCollapseAllReview]: null,
    [FunctionGroupRequestWizardTestIds.btnExpandAllFgs]: null,
    [FunctionGroupRequestWizardTestIds.btnExpandAllReview]: null,
    [FunctionGroupRequestWizardTestIds.btnNextStep]: null,
    [FunctionGroupRequestWizardTestIds.btnPreviousStep]: 'Go back to the previous wizard step — selections are preserved.',
    [FunctionGroupRequestWizardTestIds.btnSelectMyself]: null,
    [FunctionGroupRequestWizardTestIds.btnSelectSomeoneElse]: null,
    [FunctionGroupRequestWizardTestIds.btnSubmitRequest]: 'Submit the request for approval — approvers will see every selected function group.',
    [FunctionGroupRequestWizardTestIds.cardTitleReviewAndSubmit]: 'Final review of the request — verify the recipient, function groups, and access profiles before submitting.',
    [FunctionGroupRequestWizardTestIds.cardTitleSelectFunctionGroups]: null,
    [FunctionGroupRequestWizardTestIds.cardTitleWhoNeedsAccess]: null,
    [FunctionGroupRequestWizardTestIds.fgAssociationEditor]: 'Editor for adding, removing, and previewing the chosen function groups.',
    [FunctionGroupRequestWizardTestIds.reviewFgItem]: 'A single function group entry in the review summary, showing its access profiles.',
  },
}
